module.exports = __webpack_public_path__ + "static/media/UserAgencyIco.97e10fc7.svg";